import { IDuration, IServiceDosage } from '@alberta/konexi-shared';

export class ServiceDosageViewModel implements IServiceDosage {
  billingUnitId: string;
  /** the number of times the service is to be provided per iteration */
  quantity: number;
  /** the frequency of service iterations e.g. every two weeks */
  duration: IDuration;
}
